import React from 'react'
import { PurchaseOrderPage } from './purchase-order-page'

/**
 * Purchase Order Receiving Page
 * 重用现有的 PurchaseOrderPage，传入 pageType=4 来启用接收功能
 */
export const PurchaseOrderReceivingPage = () => {
  return <PurchaseOrderPage pageType={4} />
}

export default PurchaseOrderReceivingPage
